<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <kinva-doc-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import KinvaDocProvider from "../../../../providers/KinvaDocProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import KinvaDocForm from "../KinvaDocForm";
  
    

    export default {
        name: "KinvaDocUpdate",
        
        components: { KinvaDocForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'kinva.kinvaDoc.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    identifier: this.item.identifier,
                    title: this.item.title,
                    size: this.item.size
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    KinvaDocProvider.updateKinvaDoc(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateKinvaDoc)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

